
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CommonError extends Vue {
  @Prop() private errorStyle!: object;
  isDark = false;
  mounted() {
    this.isDark = window.getCssStyle() === 'black';
  }
  refresh() {
    this.$emit('refresh');
  }
}
